import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ZodiacTheme } from './zodiacThemes';
interface CreditsTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
}
export function CreditsTab({
  theme,
  onNavigate
}: CreditsTabProps) {
  return <div className="space-y-6" data-id="element-15645">
      <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-15646">
        Кредиты и Пакеты
      </h2>
      <Card padding="lg" className={`bg-gradient-to-r ${theme.gradient} text-white border-none mb-8 shadow-lg`} data-id="element-15647">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-15648">
          <div data-id="element-15649">
            <div className="text-white/80 text-sm mb-1" data-id="element-15650">Доступный баланс</div>
            <div className="text-4xl font-bold flex items-baseline" data-id="element-15651">
              2{' '}
              <span className="text-xl font-normal text-white/80 ml-2" data-id="element-15652">
                кредита
              </span>
            </div>
            <p className="text-sm text-white/80 mt-2" data-id="element-15653">
              1 кредит = 1 любой авто-отчёт. Кредиты не сгорают.
            </p>
          </div>
          <Button variant="outline" size="lg" className="bg-white text-slate-900 border-none hover:bg-slate-100" onClick={() => onNavigate('pricing')} data-id="element-15654">
            Купить пакет
          </Button>
        </div>
      </Card>

      <h3 className="font-bold text-slate-900 mb-4" data-id="element-15655">История операций</h3>
      <Card padding="none" className="overflow-hidden" data-id="element-15656">
        <table className="w-full text-left text-sm" data-id="element-15657">
          <thead className="bg-slate-50 text-slate-500" data-id="element-15658">
            <tr data-id="element-15659">
              <th className="px-6 py-4 font-medium" data-id="element-15660">Дата</th>
              <th className="px-6 py-4 font-medium" data-id="element-15661">Операция</th>
              <th className="px-6 py-4 font-medium text-right" data-id="element-15662">Изменение</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-15663">
            <tr data-id="element-15664">
              <td className="px-6 py-4 text-slate-600" data-id="element-15665">12 Окт 2024</td>
              <td className="px-6 py-4 font-medium text-slate-900" data-id="element-15666">
                Оплата авто-отчёта "Натальная карта"
              </td>
              <td className="px-6 py-4 text-right text-rose-600 font-medium" data-id="element-15667">
                -1 кредит
              </td>
            </tr>
            <tr data-id="element-15668">
              <td className="px-6 py-4 text-slate-600" data-id="element-15669">10 Окт 2024</td>
              <td className="px-6 py-4 font-medium text-slate-900" data-id="element-15670">
                Покупка пакета "3 отчёта"
              </td>
              <td className="px-6 py-4 text-right text-emerald-600 font-medium" data-id="element-15671">
                +3 кредита
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
    </div>;
}